<template>
  <v-container class="my-3 px-6 px-lg-0">
    <CarouselBanner></CarouselBanner>
    <v-row class="mb-8 d-none d-lg-flex" v-if="getConfig.storeConfig != null">
      <v-col class="d-flex align-center justify-space-between bg-white pa-1">
        <div class="border-left-custom d-flex align-center justify-center">
          <Svgs :icon="'relogio'" :color="'fill-color-2'" :width="40" :height="40"></Svgs>
        </div>
        <div class="text-color-0 w-70 text-center">
          <div class="w-100">Confira os próximos horários</div>
          <v-btn variant="outlined" density="comfortable" class="text-color-0 br-5 mt-2" @click="openDialogAddress(1)" v-if="getConfig.storeConfig.min_delivery_value_order > 0">Entrega</v-btn>
          <v-btn variant="outlined" density="comfortable" class="text-color-0 br-5 mt-2 ms-3" @click="openDialogAddress(0)" v-if="getConfig.storeConfig.min_withdrawal_value_order > 0">Retirada</v-btn>
          <DialogAddress :fechar="fechar" :model="modelAddress" :startPage="'horarios'" :startIsEntrega="startIsEntrega"></DialogAddress>
        </div>
      </v-col>
      <v-col class="d-flex align-center justify-space-between bg-white pa-1 mx-lg-4">
        <div class="border-left-custom d-flex align-center justify-center">
          <Svgs :icon="'caminhao'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
        </div>
        <div class="text-color-0 w-70 text-center">
          <div class="w-100">Valor Mínimo</div>
          <div class="w-100 d-flex justify-space-around mt-1" v-if="getConfig.storeConfig.min_express_value_order > 0 || getConfig.storeConfig.min_delivery_value_order != getConfig.storeConfig.min_withdrawal_value_order ">
            <span v-if="getConfig.storeConfig.min_express_value_order > 0">Express:<br /><b>{{ $formatNumber(getConfig.storeConfig.min_express_value_order, { style: "currency", currency: "BRL" }) }}</b></span>
            <span v-if="getConfig.storeConfig.min_delivery_value_order > 0">Entrega:<br /><b>{{ $formatNumber(getConfig.storeConfig.min_delivery_value_order, { style: "currency", currency: "BRL" }) }}</b></span>
            <span v-if="getConfig.storeConfig.min_withdrawal_value_order > 0">Retirada:<br /><b>{{ $formatNumber( getConfig.storeConfig.min_withdrawal_value_order, { style: "currency", currency: "BRL" } ) }}</b></span>
          </div>
          <div class="w-100 d-flex justify-space-around mt-1" v-else>
            <span v-if="getConfig.storeConfig.min_delivery_value_order > 0"><b>{{ $formatNumber(getConfig.storeConfig.min_delivery_value_order, { style: "currency", currency: "BRL" }) }}</b></span>
            <span v-else>Mais facilidade para você.</span>
          </div>
        </div>
      </v-col>
      <v-col class="d-flex align-center justify-space-between bg-white pa-1">
        <div class="border-left-custom d-flex align-center justify-center">
          <Svgs v-if="getConfig.storeConfig.is_op == 1" :icon="'card'" :color="'fill-color-2'" :width="40" :height="40"></Svgs>
          <Svgs v-else :icon="'cadeado'" :color="'fill-color-2'" :width="40" :height="40"></Svgs>
        </div>
        <div class="text-color-0 w-70 text-center">
          <div v-if="getConfig.storeConfig.is_op == 1" class="w-100">Disponível<br>Pagamento Online</div>
          <div v-else class="w-100">Loja confiável e segura</div>
        </div>
      </v-col>
    </v-row>
    <CarouselProduct :offers="true" v-if="mobile == false && getTabsClusterOffers != null && getTabsClusterOffers.length > 0"></CarouselProduct>
    <v-row class="mb-8 d-none d-lg-block">
      <v-col class="bg-color-1 d-flex align-center justify-center text-white pa-7">
        <Svgs :icon="'cesta'" :color="'fill-color-white'" :width="50" :height="50"></Svgs>
        <span class="text-xlarge font-weight-black font-italic ms-5">{{ modalidadeTexto }}</span>
      </v-col>
    </v-row>
    <CarouselProduct :offers="false" :tabProp="getContainers(0)" v-if="mobile == false && getContainers(0) != null"></CarouselProduct>
    <v-row v-if="mobile == false && getBannersHome && getBannersHome.length > 0" class="d-none d-lg-flex mb-8">
      <v-col v-for="(banner, index) in getBannersHome" v-bind:key="index" class="pa-0" v-bind:class="index == 1 ? 'mx-lg-4' : ''">
        <Banner :banner="banner"></Banner>
      </v-col>
    </v-row>
    <CarouselProduct :offers="false" :tabProp="getContainers(1)" v-if="mobile == false && getContainers(1) != null"></CarouselProduct>
    <CarouselProduct :offers="false" :tabProp="getContainers(2)" v-if="mobile == false && getContainers(2) != null"></CarouselProduct>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CarouselProduct from "@/components/CarouselProduct.vue";
import CarouselBanner from "@/components/CarouselBanner.vue";
import Banner from "@/components/Banner.vue";
import Svgs from "@/components/Svgs.vue";
import DialogAddress from "@/components/DialogAddress.vue";

export default {
  name: "Home",
  components: {
    CarouselProduct,
    CarouselBanner,
    Banner,
    Svgs,
    DialogAddress,
  },
  data() {
    return {
      modelAddress: false,
      startIsEntrega: null,
      mobile: true,
      previouswidth: 0,
    };
  },
  computed: {
    ...mapGetters("main", {
      getConfig: "getConfig",
      getBannersHome: "getBannersHome",
      getTabsClusterOffers: "getTabsClusterOffers",
      getCategoryCarrossel: "getCategoryCarrossel",
      getTabs: 'getTabs',
      getContainers: "getContainers"
    }),
    modalidadeTexto() {
      if (!this.getConfig?.storeConfig) return "";

      const modos = [];
      const cfg = this.getConfig.storeConfig;

      if (cfg.min_express_value_order !== -1) modos.push("EXPRESS");
      if (cfg.min_delivery_value_order !== -1) modos.push("ENTREGA");
      if (cfg.min_withdrawal_value_order !== -1) modos.push("RETIRADA");

      if (modos.length === 0) return "";

      const lista =
        modos.length === 1
          ? modos[0]
          : modos.slice(0, -1).join(", ") + " OU " + modos[modos.length - 1];

      return `COMPRE ONLINE E ESCOLHA ${lista}. MAIS CONFORTO E COMODIDADE PARA VOCÊ.`;
    },
  },
  methods: {
    ...mapActions("main", {
      setConfig: "setConfig",
      getBanners: "getBanners",
      getFixedBanners: "getFixedBanners",
      loadContainers: "getContainers"
    }),
    checkLayout() {
      var val = window.innerWidth;
      if (parseFloat(val) < 1280 && this.previouswidth != val) {
        this.previouswidth = window.innerWidth;
        let tab = this.getTabs[0];
        if(tab.type == 3){
          this.$router.push("/feed/"+tab.id);
        } else {
          this.$router.push("/offers/2");
        }
      } else {
        this.mobile = false;
      }
    },
    fechar: function () {
      this.modelAddress = false;
    },
    openDialogAddress(startIsEntrega) {
      if(this.getConfig.isu > 0){
        this.startIsEntrega = startIsEntrega;
        this.modelAddress = true;
      } else {
        this.emitter.emit('dialogLogin');
      }
    },
  },
  mounted() {
    this.setConfig().then(
      function (retorno) {
        if (retorno) {
          this.checkLayout();
          this.loadContainers();
          this.getBanners();
          this.getFixedBanners();
          window.addEventListener("resize", this.checkLayout);
          if (this.getConfig.storeConfig != null && this.getConfig.storeConfig.is_nps != null) {
            this.emitter.emit("dialogNPS", {
              order_id: this.getConfig.storeConfig.is_nps > 0 ? this.getConfig.storeConfig.is_nps : null
            });
          } else if (this.getConfig.storeConfig != null && this.getConfig.storeConfig.is_nps == null && this.getConfig.storeConfig.is_physical_nps == 1) {
            this.emitter.emit("dialogNPS", {
              order_id: this.getConfig.storeConfig.last_sale_id,
              is_physical_nps: 1
            });
          }
        } else {
          this.emitter.emit("dialogStores");
        }
        this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
      }.bind(this)
    ).catch(
      function () {
        this.$router.push("/baixeoapp");
      }.bind(this)
    );
  },
  unmounted() {
    window.removeEventListener("resize", this.checkLayout);
  },
};
</script>